import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PecasSolicitadasService } from '../pecas-solicitadas-service/pecas-solicitadas.service';
import { CrudBase } from './../../../../shared/crud/CrudBase';
import { ListitemBuilder } from './../../../../shared/dropdown-list/ListItemBuilder';
import { Estado } from './../../../../shared/shared/estado.enum';
import { TextBoxComponent } from './../../../../shared/text-box/text-box.component';
import { FiltroService } from '../../../../shared/filtro/filtro.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-pecas-solicitadas-cadastro',
  templateUrl: './pecas-solicitadas-cadastro.component.html',
  styleUrls: ['./pecas-solicitadas-cadastro.component.css']
})
export class PecasSolicitadasCadastroComponent
  extends CrudBase
  implements OnInit {

  @ViewChild('inputvalor') inputValor: TextBoxComponent;

  itensTipo: any;
  dealer: any;
  meses: any;

  todos: boolean = false;
  carregando: boolean = false;

  constructor(
    service: PecasSolicitadasService,
    toastr: ToastrService,
    private filtroService: FiltroService) {
    super(service, toastr);
  }

  ngOnInit() {
    if (!this.model) {
      this.model = {}
    }
    this.defineModelVazio();
    this.carregarMeses();
  }

  novo() {
    super.novo()
    this.defineModelVazio();
  }

  salvar() {
    this.model.valor = this.model.valor.toString().replace(",", ".");
    if (this.todos == true) {
      this.filtroService.buscar("dealer").then(res => {
        for (let i = 0; i < res.filtros.length; i++) {
          this.model.id_dealer = res.filtros[i].id.toString();
          super.salvar();
        }
      });
    } else {
      super.salvar();
    }
  }

  public todosDealers() {
    this.carregando = true;
    this.todos = !this.todos;
    this.model.id_dealer = 1;
    this.carregando = false;
  }

  // == [ INICIO: Métodos Auxiliares ] ==
  private defineModelVazio() {
    if (this.state === Estado.insert) {
      this.model.id = null;
      this.model.id_dealer = '';
      this.model.mes = '';
    }
  }

  // == [ FIM:    Métodos Auxiliares ] ==
  private carregarMeses() {
    this.meses =
      new ListitemBuilder()
        .add('1', 'Janeiro')
        .add('2', 'Fevereiro')
        .add('3', 'Março')
        .add('4', 'Abril')
        .add('5', 'Maio')
        .add('6', 'Junho')
        .add('7', 'Julho')
        .add('8', 'Agosto')
        .add('9', 'Setembro')
        .add('10', 'Outubro')
        .add('11', 'Novembro')
        .add('12', 'Dezembro')
        .build();
  }

  public uploader(event) {
    const json = this.convertExcelToJson(event);
  }

  private convertExcelToJson(ev) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.files[0];

    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        let sheet = workBook.Sheets[name];

        // Validar header do excel; Remove espaço em branco

        if (sheet.A1 !== undefined && sheet.B1 !== undefined && sheet.C1 !== undefined && sheet.D1 !== undefined) {
          sheet.A1.w = sheet.A1.w.trim();
          sheet.B1.w = sheet.B1.w.trim();
          sheet.C1.w = sheet.C1.w.trim();
          sheet.D1.w = sheet.D1.w.trim();
        }

        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      this.insertArquivo(JSON.stringify(jsonData));
    }
    reader.readAsBinaryString(file);
  }

  insertArquivo(json) {
    var row = JSON.parse(json)
    var verifica = this.verificaArquivo(row);
    if (verifica) {
      for (let i = 0; i < row.NBS.length; i++) {
        if (typeof row.NBS[i].dealer === "undefined" || typeof row.NBS[i].mes === "undefined" || typeof row.NBS[i].ano === "undefined" || typeof row.NBS[i].valor === "undefined") {
          alert('Arquivo com erro na linha ' + (i + 2));
        } else {
          this.model.id = "0";
          this.model.id_dealer = row.NBS[i].dealer.toString();
          this.model.mes = row.NBS[i].mes.toString();
          this.model.ano = row.NBS[i].ano.toString();
          this.model.valor = row.NBS[i].valor.toString();
          super.salvar();
          this.defineModelVazio();
        }
      }
    }
  }

  verificaArquivo(row) {
    var teste = [];
    for (let i = 0; i < row.NBS.length; i++) {
      teste.push(row.NBS[i].dealer?.toString() + row.NBS[i].categoria?.toString() + row.NBS[i].mes?.toString() + row.NBS[i].ano?.toString() + row.NBS[i].valor?.toString());
    }
    if (!this.hasDuplicates(teste)) {
      return true;
    } else {
      const mensagem = 'Arquivo Com Itens Duplicados';
      this.toastr.error(mensagem, 'Erro no Arquivo')
    }
  }

  hasDuplicates(array) {
    return (new Set(array)).size !== array.length;
  }

}
